interface ProfileIncompleteModalProps {
  isOpen: boolean
  onConfirm: () => void
}

export function ProfileIncompleteModal({ isOpen, onConfirm }: ProfileIncompleteModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6 shadow-xl">
        <div className="text-center">
          {/* Icon */}
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-orange-100 mb-4">
            <svg className="h-6 w-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.502 0L4.312 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>

          {/* Title */}
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Profile Completion Required
          </h3>

          {/* Message */}
          <p className="text-sm text-gray-500 mb-6">
            You must complete your user profile before accessing the site. This helps us provide you with a personalized experience and ensures you have access to all the features designed for your business needs.
          </p>

          {/* Button */}
          <button
            onClick={onConfirm}
            className="w-full inline-flex justify-center px-4 py-2 bg-orange-600 text-white text-sm font-medium rounded-md hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 transition-colors"
          >
            Complete Profile Now
          </button>
        </div>
      </div>
    </div>
  )
} 